import { Button, Container } from '@material-ui/core'
import { Info } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'

const NotFound = () => {
  const history = useHistory()

  return (
    <Container>
      <div className="p-t-150 text-center">
        <Info style={{ width: 42, height: 42 }} />
        <div className="strong fs20 m-t-32">Sorry this page can’t be found</div>
        <div>
          The link you followed may be broken or the page may have been removed.
        </div>

        <Button
          className="m-t-32 btn-gradient"
          color="primary"
          onClick={() => history.push('/myquality/dashboard')}
        >
          Go to dashboard
        </Button>
      </div>
    </Container>
  )
}

export default NotFound
